import type { ReactNode } from "react";
import PageLayout from "./layout";

export default function (): ReactNode {
  return (
    <PageLayout title="Reference Data Platform">
      <section>
        <h2>Reference Data Platform</h2>
        <p>Please select a component to manage</p>
      </section>
    </PageLayout>
  );
}
